'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EpisodeService = function () {
    function EpisodeService($http, $rootScope) {
        _classCallCheck(this, EpisodeService);

        if ($rootScope && $rootScope.globals) $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
        this.$http = $http;
    }

    _createClass(EpisodeService, [{
        key: 'editEpisodeDetails',
        value: function editEpisodeDetails(data) {
            return this.$http({
                method: 'POST',
                url: WEBSERVICEURL + '/dataagility/api/service.episodeaudit/',
                data: data,
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });
        }
    }]);

    return EpisodeService;
}();

var EpisodesController = function EpisodesController($http, $scope, $timeout, DTOptionsBuilder, DTColumnBuilder, CONST, materialButtons, LxDialogService, $rootScope, FunctionService) {
    _classCallCheck(this, EpisodesController);

    $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
    this.name = 'Admin - Episodes';
    this.specialtyString = '';
    this.separationString = '';
    this.datatableApi;
    this.url = WEBSERVICEURL + '/dataagility/api/service.episodeaudit/getepisodes/';
    this.dtInstance = {};
    this.model = {};
    this.dateTypeOptions = [{ value: 'SEPARATION_DATE', viewValue: 'Separation Date' }, { value: 'CODED_DATE', viewValue: 'Coded Date' }];
    this.EOFY = moment("30/06/" + moment().format('YYYY'), "DD/MM/YYYY");
    this.startFinYear;
    this.endFinYear;
    this.startFinYearDisplay;
    this.endFinYearDisplay;

    if (moment().isAfter($scope.vm.EOFY)) {
        this.startFinYear = moment().subtract(1, 'year').month('July').startOf('month');
        this.endFinYear = moment().add(1, 'year').month('June').endOf('month');
    } else {
        this.startFinYear = moment().subtract(2, 'year').month('July').startOf('month');
        this.endFinYear = moment().month('June').endOf('month');
    }

    this.startFinYearDisplay = this.startFinYear.format('L');
    this.endFinYearDisplay = this.endFinYear.format('L');

    // Search filters
    this.searchFilter = "";

    this.status = {
        selectedStatus: undefined
    };
    this.statusOptions = CONST.STATUS;
    this.locale = 'en-au';

    materialButtons.render();
    materialButtons.processing();

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
        $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
    });

    $scope.drawCallback = function (settings) {
        componentHandler.upgradeAllRegistered();
        // reset model
        $scope.vm.model = [];
        var table = $('#auditTable').DataTable();

        table.rows().every(function (rowIdx, tableLoop, rowLoop) {
            var data = this.data();
            $scope.vm.model[rowLoop] = [];
            $scope.vm.model[rowLoop].episodeAuditId = data.episodeAuditId;
        });
    };

    $scope.initCallback = function (nRow, aData, index) {
        // Datatables has finished init
        // Initialise searching
        if ($scope.vm.datatableApi) return;

        $scope.vm.datatableApi = this.api();

        // Update column headers even when no data returned
        setDtHeaders($scope.vm.datatableApi);

        // set the table to a fixed height, so it never collapsed up and down
        $('#auditTable').closest(".dataTables_scrollBody").height(300);

        // setup global search filter
        search();
    };

    this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
        headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
        url: $scope.vm.url,
        type: 'GET',
        // Send additional data for processing server-side filters
        data: function data(d) {
            d.startDate = $scope.vm.startFinYearDisplay;
            d.endDate = $scope.vm.endFinYearDisplay;
            d.dateType = $scope.vm.dateTypeOptions[0].value;
            d.auditCriteria = '';
            d.status = '';
            d.specialty = '';
            d.search = $scope.vm.searchFilter || '';
        },
        error: function error(xhr, _error, thrown) {
            if (thrown == 'Unauthorized') {
                //window.location.replace(window.location.origin + '/login');
                console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
            }
        }
    }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('serverSide', true).withOption('order', [[2, 'asc']]).withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
        // Update column headers if data returned
        setDtHeaders($('#auditTable').DataTable());
    }).withOption('initComplete', $scope.initCallback)
    // .withOption('rowCallback', $scope.rowCallback)
    .withOption('drawCallback', $scope.drawCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
        extend: 'print',
        text: ''
    }, {
        extend: 'csvHtml5',
        text: '',
        filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
    }, {
        extend: 'excelHtml5',
        text: '',
        filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
    }, {
        text: '',
        action: function action(e, dt, node, config) {
            $scope.vm.dtInstance.reloadData();
        }
    }]);

    this.dtColumns = [DTColumnBuilder.newColumn('episodeNumber').withTitle('Episode Number').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('urn').withTitle('UR Number').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeDate').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('drg').withTitle('Current DRG').withOption('defaultContent', '0').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
        if (typeof full.currentDRGDescription !== 'undefined') {
            return full.currentDRG + ' - ' + full.currentDRGDescription;
        } else {
            return full.currentDRG;
        }
    }), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('status').withTitle('Status').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')];

    function setDtHeaders(table) {
        $(table.column(2).header()).html($scope.vm.separationString + ' Date');
        $(table.column(4).header()).html($scope.vm.specialtyString);
    }

    this.changeData = changeData;

    this.resetSelectors = resetSelectors;

    function resetSelectors() {
        $scope.vm.status.selectedStatus = undefined;
    }

    function checkParam(param) {
        if (param.length !== 0) {
            return encodeURIComponent(param.join());
        } else {
            return "";
        }
    }

    function changeData() {
        $scope.vm.dtInstance.changeData({
            method: 'GET',
            headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
            url: '' + $scope.vm.url + '?startDate=' + $scope.vm.startFinYearDisplay + '&endDate=' + $scope.vm.endFinYearDisplay + '&dateType=' + $scope.vm.dateTypeOptions[0].value + '&auditCriteria=' + '&status=' + '&specialty=' + '&search=' + $scope.vm.searchFilter + '&controller=episodes' + '',
            error: function error(xhr, _error2, thrown) {
                if (thrown == 'Unauthorized') {
                    //window.location.replace(window.location.origin + '/login');
                    console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
                }
            } });
    }

    function search() {
        var timeoutPromise,
            delayInMs = 500;

        $scope.$watch("vm.searchFilter", function (searchString, oldvalue) {
            $timeout.cancel(timeoutPromise); //does nothing, if timeout already done
            timeoutPromise = $timeout(function () {
                //Set timeout
                if (searchString !== oldvalue) {
                    $scope.vm.changeData();
                }
            }, delayInMs);
        });
    }

    this.openDialog = openDialog;

    function openDialog(_newValue, _oldValue) {
        if (!_newValue) return;

        if ($scope.vm.model.length !== 0) {
            LxDialogService.open("doubleCheck");
        } else {
            $scope.vm.resetSelectors();
        }
    }

    $scope.snackBar = function (message) {
        // upgrade MDI components
        window.componentHandler.upgradeAllRegistered();

        var snackbarContainer = document.querySelector('#audit__notification');
        var data = {
            message: message,
            timeout: 2000,
            actionHandler: $scope.finaliseCheck,
            actionText: 'test'
        };
        snackbarContainer.MaterialSnackbar.showSnackbar(data);
    };

    // FORM SUBMISSION
    this.setStatus = setStatus;

    function setStatus() {
        this.serialize = function (obj) {
            var str = [];
            for (var p in obj) {
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            }return str.join("&");
        };

        var modelLength = $scope.vm.model.length - 1;

        angular.forEach($scope.vm.model, function (value, key) {

            if ($scope.vm.status.selectedStatus) $scope.vm.model[key].status = $scope.vm.status.selectedStatus;

            new EpisodeService($http).editEpisodeDetails($scope.vm.serialize($scope.vm.model[key])).then(function successCallback(response) {
                if (key === modelLength) {
                    // Episodes updated
                    $scope.vm.dtInstance.reloadData();
                    $scope.vm.resetSelectors();
                    $scope.snackBar('Episode/s updated');
                }
            }, function errorCallback(response) {
                if (response.status === 401) {
                    window.location.replace(window.location.origin + '/login?logout=true');
                }
            });
        });
    }
};

exports.default = EpisodesController;


// WEBPACK FOOTER //
// ./client/app/common/admin/episodes/episodes.controller.js